/**
 * Vendors ´Cookie consent´
 */

import {
	lockBodyScrolling,
	unlockBodyScrolling
} from '../../../shared/js/utils/scroll';
import {loadScript} from '../../../shared/js/utils/load-script';

import SelectorEngine from '../../../shared/js/dom/selector-engine';
import EventHandler from '../../../shared/js/dom/event-handler';
import Manipulator from '../../../shared/js/dom/manipulator';

import iframeResize from '../../../../node_modules/@iframe-resizer/parent';
import Leaflet from "../leaflet/init-leaflet";

// -------
// Private
// -------

window.dataLayer = window.dataLayer || [];
window.GtagLoaded = false;

const gtagInit = function(id, lib) {
	if(!window.GtagLoaded) {
		window['dataLayer'].push({
			config: id,
			js    : new Date()
		});

		const firstScript = document.getElementsByTagName('script')[0];
		const newScript   = document.createElement('script');

		newScript.async = true;
		newScript.src   = `${lib}${id}`;

		firstScript.parentNode.insertBefore(newScript, firstScript);

		window.GtagLoaded = true;
	}
};

// ------
// Public
// ------

const init = () => {
	let inst = null;

	if (typeof ScCookie !== 'undefined') {
		inst = new ScCookie({
			on: {
				showPreferences: function() {
					lockBodyScrolling(this);
				},
				hidePreferences: function() {
					unlockBodyScrolling(this);
				},
				saveConsent    : function(consent) {
					document.location.reload();
				},
				init           : function(consent) {
					// Youtube?
					if (this.getConsent('youtube')) {
						const collection = SelectorEngine.find('[data-player-type="youtube"]');

						for (const element of collection) {
							EventHandler.trigger(element, 'disable.privacyMode');
						}
					}

					// Vimeo?
					if (this.getConsent('vimeo')) {
						const collection = SelectorEngine.find('[data-player-type="vimeo"]');

						for (const element of collection) {
							EventHandler.trigger(element, 'disable.privacyMode');
						}
					}

					// Google Analytics?
					if (this.getConsent('googleanalytics')) {
						const gtmId = window.pageInstance.settings.statistic.gtm.id ?? 'UA-121790273-1';

						// Google Tag Manager einbinden
						gtagInit(gtmId, 'https://www.googletagmanager.com/gtag/js?id=');
						window.dataLayer.push({
							event : 'cookieOptInGoogleAnalytics'
						});

						// // eslint-disable-next-line unicorn/no-document-cookie

						// document.cookie                  = 'ga-disable-UA-129301-1=false; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/';
						// window['ga-disable-UA-129301-1'] = false;
					// } else {

						// 	// eslint-disable-next-line unicorn/no-document-cookie
						// 	document.cookie                  = 'ga-disable-UA-129301-1=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/';
						// 	window['ga-disable-UA-129301-1'] = true;
						//
					}

					// Solar Calculator
					if (this.getConsent('solarcalculator')) {
						const collection = SelectorEngine.find('[data-ce="solar-calculator"]');

						for (const element of collection) {
							let iframe = SelectorEngine.findOne('iframe', element);
							let src = Manipulator.getDataAttribute(iframe, 'src');
							let privacyMsg = SelectorEngine.findOne('.privacy-info', element);

							EventHandler.trigger(element, 'disable.privacyMode');
							iframe.src = src;
							Manipulator.removeDataAttribute(iframe, 'src');

							privacyMsg.outerHTML = '';

							iframe = iframeResize({ license: 'GPLv3', waitForLoad: true }, iframe);
						}
					}


					// OpenStreetMap
					if (this.getConsent('maps')) {
						const collection = SelectorEngine.find('[data-privacy="googlemaps"]');

						for (const element of collection) {
							Manipulator.removeDataAttribute(element, 'privacy');
						}

						loadScript('https://maps.googleapis.com/maps/api/js?key=AIzaSyCFBkS4ewthiM5c4YZEeU0psEJvR9eZS9o',
							{
								async: true,
								id   : 'googleMapsApi',
								callback : () => {
									setTimeout(function() {
										Leaflet.init();
									}, 200);

								}
							}
						);
					}
				}
			}
		});
	}

	// Custom-Trigger für Cookie-Einstellungen anzeigen.
	EventHandler.on(document.body, 'click', '[data-privacy-settings]', (event) => {
		event.stopPropagation();

		window.ifabCookieConsent.togglePreferences();
	});

	return window.ifabCookieConsent = inst;
};

// Export
export default init;
